import styled, { keyframes } from "styled-components";
import { duration, easing } from "../../../design-system/tokens/transitions";
import { spacing, typographyMixin, rawColors, borderRadius } from "@magicbi/ui-library";

const pillIn = keyframes`
  from { opacity: 0; transform: scale(0.96); }
  to { opacity: 1; transform: none; }
`;
const barPulse = keyframes`
  0%, 100% { transform: scaleY(1); }
  50% { transform: scaleY(0.55); }
`;

/** Disabled "Listening" pill: 36px, full radius, teal tint. */
export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  height: ${spacing[9]};
  padding: 0 ${spacing[3]};
  ${typographyMixin("caption", 1)}
  color: ${rawColors.accent.cross.text};
  background: ${rawColors.accent.cross.bg};
  border-radius: ${borderRadius.full};
  cursor: not-allowed;
  animation: ${pillIn} ${duration.normal} ${easing.slideIn} both;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Bars = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[0.5]};
  height: ${spacing[4]};
`;

/** GAP: 3px wide bars of 6/14/9/16/7px have no tokens; px and rem literals follow the design. */
export const Bar = styled.i<{ $height: string; $index?: number }>`
  width: 0.1875rem;
  height: ${({ $height }) => $height};
  background: ${rawColors.secondary[700]};
  border-radius: ${borderRadius.xs};
  /* A gentle level pulse, staggered per bar; the calm duration is a few times the motion token. */
  animation: ${barPulse} calc(${duration.slower} * 2.4) ${easing.smooth} infinite;
  animation-delay: ${({ $index = 0 }) => `calc(${duration.fast} * ${$index})`};
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
